import axios from './axios'
import { ElLoading } from 'element-plus'
export function getReport01 (callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/pos_report/report01').then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function printReport (printID, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/pos_report/print/' + printID).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}


export function getReport01Child (flag,printID,callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/pos_report/report01/child/'+flag+"/"+printID).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}